import { gql } from '@apollo/client';

const Fragments = {
  exchangeRateItem: gql`
    fragment exchangeRateItem on ExchangeRateItem {
      exchangeRateId
      currencyId
      refCurrencyId
      partnerId
      exchangeRateDate
      exchangeRate1
      exchangeRate2
      siteId
    }
  `
};
export default Fragments;
